import React, {FC, useState, useEffect} from "react"

import authentication from "@irati/auth"
import FormattedMessage, {getMessage, FormattedCurrency, InjectIntl, injectIntl} from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Body, H2, H4} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import buService from "@irati/billing/services/bu"
import ErrorText from "@irati/ui/src/ErrorText"
import {getErrorMessage, getErrorValues} from "@irati/utils/lang/formatError"

import {DSYNC_INTEGRATION} from "./Upsell"

interface Props extends InjectIntl {}

const FirstMonthFreeOfferBanner: FC<Props> = ({formatMessage}) => {
  const [currency, setCurrency] = useState<string>()
  const [price, setPrice] = useState<number>()
  const [error, setError] = useState<string>()

  const theme = useTheme()

  useEffect(() => {
    const businessId = authentication.business().uuid

    buService
      .getProductOptions({businessId})
      .then(({newProducts, currency: productCurrency}) => {
        const product = newProducts?.find((item) => item?.name === DSYNC_INTEGRATION)

        if (product?.pricePerSeatPerMonth && productCurrency) {
          setPrice(product?.pricePerSeatPerMonth)
          setCurrency(productCurrency)
        }
      })
      .catch((err: PBError) => {
        const message = getMessage(formatMessage, getErrorMessage(err), getErrorValues(err))
        setError(message)
      })
  }, [])

  return (
    <>
      {currency && price && (
        <Flex alignItems="baseline" wrap="wrap" marginBottom={2}>
          <H2 color={theme.colors.greys.black}>
            <FormattedCurrency isCents value={price} currency={currency} />/
          </H2>
          <H4 marginRight={2} color={theme.colors.greys.black}>
            <FormattedMessage id="admin.components.integration.directorySync.hris.offerBanner.perMonth" />
          </H4>
          <Flex alignSelf="center">
            <Card noBorder bgColor={theme.colors.success} padding={[0, 1]}>
              <Body small color={theme.colors.greys.white}>
                <FormattedMessage id="admin.components.integration.directorySync.hris.offerBanner.firstMonthFree" />
              </Body>
            </Card>
          </Flex>
        </Flex>
      )}
      {error && (
        <Flex marginBottom={2}>
          <ErrorText>{error}</ErrorText>
        </Flex>
      )}
    </>
  )
}

export default injectIntl(FirstMonthFreeOfferBanner)
